import React__default from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { useSelector, useIntl } from '@grandvisionhq/state';
import { PupillaryDistanceLink } from './PupillaryDistanceLink.js';
import { getPrescriptionType } from '../../../../../state/configurator/selectors.js';

const PupillaryDistanceLinkContainer = ({ className  })=>{
    const prescriptionType = useSelector(getPrescriptionType);
    const { hasLabel , getFormattedLabel  } = useIntl();
    const pdLinkLabelKey = CommerceToolsApi.isPrescriptionFile(prescriptionType) ? 'products.glasses.prescription.form.pdMeasurementLink' : 'products.glasses.prescription.form.pdLink';
    const labels = React__default.useMemo(()=>({
            pdLinkLabel: hasLabel(pdLinkLabelKey) ? getFormattedLabel(pdLinkLabelKey, {
                parseLink: true,
                openLinksInNewTab: true
            }) : ''
        })
    , [
        hasLabel,
        getFormattedLabel
    ]);
    return /*#__PURE__*/ React__default.createElement(PupillaryDistanceLink, {
        className: className,
        labels: labels
    });
};

export { PupillaryDistanceLinkContainer };
//# sourceMappingURL=PupillaryDistanceLinkContainer.js.map
